export { default, type AccordionItemProps } from './accordion-item';
